"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Activity_1 = require("@opsbase/lib-issue/Activity");
const Flag_1 = require("@opsbase/lib-issue/Flag");
const IssueStatus_1 = require("@opsbase/lib-issue/IssueStatus");
const useSelf_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const react_1 = __importDefault(require("react"));
const ActivityDetail = ({ str, what }) => {
    var _a, _b;
    const self = (0, useSelf_1.default)();
    switch (what) {
        case Activity_1.IssueActivityEditableProperty.DEADLINE_DATE:
            return (react_1.default.createElement("span", { style: { fontFamily: 'Gilroy', fontWeight: 'bold' } }, (0, moment_timezone_1.default)(str).format('ll')));
        case Activity_1.IssueActivityEditableProperty.FLAG:
            return (react_1.default.createElement("span", { style: {
                    fontFamily: 'Gilroy',
                    fontWeight: 'bold',
                    color: (0, Flag_1.flagColor)(str).toString(),
                } }, (_a = self.settings.flagNames[str]) !== null && _a !== void 0 ? _a : 'Uncategorised'));
        case Activity_1.IssueActivityEditableProperty.STATUS:
            return (react_1.default.createElement("span", { style: {
                    fontFamily: 'Gilroy',
                    fontWeight: 'bold',
                    color: (0, IssueStatus_1.issueStatusColor)(str).main,
                } }, (0, IssueStatus_1.issueStatusLabel)(str)));
        case Activity_1.IssueActivityEditableProperty.TYPE:
            return (react_1.default.createElement("span", { style: { fontFamily: 'Gilroy', fontWeight: 'bold' } }, (_b = self.settings.issueTypes.find(z => z.key === str)) === null || _b === void 0 ? void 0 : _b.title));
        case Activity_1.IssueActivityEditableProperty.TITLE:
            return react_1.default.createElement("span", { style: { fontFamily: 'Gilroy', fontWeight: 'bold' } }, str);
        default:
            return react_1.default.createElement("span", { style: { fontStyle: 'italic' } }, str);
    }
};
exports.default = ActivityDetail;
